module.exports = __webpack_public_path__ + "static/media/Dewgong_gaussian2.64feea5d.png";